import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Company } from '../models/models';

export interface UploadQueryParams {
  companyId: string | null;
  category: string | null;
  folderId: string;
}

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private http: HttpClient) {}

  getCompanies() {
    return this.http.get<Company[]>(`${environment.apiUrl}/companies`);
  }

  upload(file: File, { category, companyId, folderId }: UploadQueryParams) {
    const formData = new FormData();
    formData.append('formFile', file);
    formData.append('category', category ?? '');
    formData.append('companyId', companyId ?? '');
    formData.append('folderId', folderId);

    return this.http.post<Document>(`${environment.apiUrl}/companyDocuments`, formData);
  }

  download(documentId: number): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/companyDocuments/${documentId}`, {
      responseType: 'blob'
    });
  }

  delete(documentId: number) {
    return this.http.delete(`${environment.apiUrl}/companyDocuments/${documentId}`);
  }
}
